<template>
    <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}" class="text-monospace"> 
        <Backer />
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px; text-align: center;">Special Orders</div>
        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <div>

                <div>
                    <div style="display: inline-block; vertical-align: top; width: 100%; margin: 5px;">
                        <!-- <div style="display: inline-block;">Filter: </div>
                        <b-input style="display: inline-block; max-width: 400px; margin-right: 5px;" v-on:keyup="filterPurchaseOrders" v-model="query" placeholder="Filter by PO #, Container #, Vendor, SKU, etc."></b-input> -->
                        <div style="display: inline-block;">
                            <div style="display: inline-block;">Order By: </div>
                            <div style="display: inline-block;">
                                <b-form-select
                                    v-model="order_key"
                                    :options="order_keys"
                                    size="sm"
                                    v-on:change="sortby"
                                >
                                </b-form-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <table style="width: 100%;">
                        <thead>
                            <tr style="background: #f2f2f2;">
                                <td class="ipt_tdhr">
                                    CREATED
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr">
                                    VENDOR
                                </td>
                                <td class="ipt_tdhr">
                                    LOCATION
                                </td>
                                <td class="ipt_tdhr">
                                    SKU 
                                </td>
                                <td class="ipt_tdhr">
                                    QTY 
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    STATUS 
                                </td>
                                <td class="ipt_tdhr" style="width: 200px;">
                                    PO #
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    ETA
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="purchase_order, idx in purchase_orders_to_show" v-bind:key="idx">
                                
                                <td class="ipt_tdhr">
                                    <div>{{ purchase_order.create_date }}</div>
                                </td>
                                
                                <td class="ipt_tdhr">
                                    <div>{{ purchase_order.invoice_id }}</div>
                                </td>
                                
                                <td class="ipt_tdhr">
                                    {{ (packet.vendorsdict[purchase_order.vendor] || "") }}
                                </td>
                                
                                <td class="ipt_tdhr">
                                    {{ packet.locationsdict[purchase_order.location_id] }}
                                </td>
                                
                                <td class="ipt_tdhr">
                                    {{ purchase_order.product_sku }}
                                </td>
                                
                                <td class="ipt_tdhr">
                                    {{ purchase_order.quantity }}
                                </td>
                                
                                <td class="ipt_tdhr">
                                    <b-form-select size="sm" :options="production_statuses" v-model="purchase_order.so_status">
                                    </b-form-select>
                                </td>
                                
                                <td class="ipt_tdhr">
                              
                                    <b-input size="sm" v-model="purchase_order.so_po_number"></b-input>
                                </td>

                                <td class="ipt_tdhr">
                                    <b-form-datepicker 
                                        reset-button
                                        size="sm" 
                                        placeholder="" 
                                        v-model="purchase_order.so_eta"
                                        :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    >        
                                    </b-form-datepicker>
                                </td>
                                
                                <td class="ipt_tdhr">
                                    <b-button size="sm" variant="success" @click="updateSpecialOrder(purchase_order)">SAVE</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "ListSpecialOrders",
        components: {Backer, VueGoodTable, Multiselect},
        data: function() {
            return {
                userDetails: {properties: {}},
                purchase_orders: [],
                purchase_orders_to_show: [],
                items_being_loaded: false,
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                vendors: [],
                vendorsdict: {},
                categories: [],
                categoriesdict: {},
                query: null,
                order_key: null,
                order_keys: [
                    {value: "eta_asc", text: "ETA (Asc)"},
                    {value: "eta_desc", text: "ETA (Desc)"},
                    {value: "create_date_asc", text: "Date Created (Asc)"},
                    {value: "create_date_desc", text: "Date Created (Desc)"},
                    {value: "vendor", text: "Vendor"},
                    {value: "location", text: "Location"}
                ],
                production_statuses: [
                    {value: "ORDERED", text: "ORDERED"},
                    {value: "BACKORDER", text: "BACKORDER"},
                    {value: "DISCONTINUED", text: "DISCONTINUED"},
                ],
                production_statuses_dict: {
                    "ORDERED": "ORDERED",
                    "BACKORDER": "BACKORDER",
                    "DISCONTINUED": "DISCONTINUED",
                }
            }
        },
        methods: {
            filterPurchaseOrders: function(){
                let query = this.query;
                let that = this;
                this.purchase_orders_to_show =  this.purchase_orders.filter(function(d){
                    return (
                        d.container_number.toLowerCase().indexOf(query.toLowerCase()) > -1  
                        ||
                        d.po_number.toLowerCase().indexOf(query.toLowerCase()) > -1
                        ||
                        that.packet.vendorsdict[d.vendor_id].toLowerCase().indexOf(query.toLowerCase()) > -1
                        ||
                        d.items.map(function(i){return i.product_sku }).join(" ").toLowerCase().indexOf(query.toLowerCase()) > -1
                    )
                });
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else{
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function() {
                let that = this;
                let path = "/api/inventory/get_special_orders/";
                let data = {};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.purchase_orders = response.data.result;
                        that.purchase_orders_to_show = response.data.result;
                    }
                    that.items_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading purchase orders.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                    return
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            sortby: function(key) {
                this.items_being_loaded = true;
                if (key == "eta_asc"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "so_eta")
                }
                if (key == "eta_desc"){
                    this.purchase_orders_to_show = Requestor.sort_reverse(this.purchase_orders_to_show, "so_eta")
                }
                if (key == "create_date_asc"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "create_date")
                }
                if (key == "create_date_desc"){
                    this.purchase_orders_to_show = Requestor.sort_reverse(this.purchase_orders_to_show, "create_date")
                }
                if (key == "vendor"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "vendor")
                }
                if (key == "location"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "location_id")
                }
                this.items_being_loaded = false;
            },
            updateSpecialOrder: function(item) {
                let data = item;
                let path = "/api/inventory/update_special_order/"
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Updated!", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error updating special order", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                Requestor.postSyncP(path, data, this, s, f);
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails); 
            this.fetch_prereqs();
            this.fetch_init();
        }
    }

</script>

<style scoped>
    .info_table td {
        font-size: 13px;
        background: #fafafa;
        margin: auto;
        text-align: center;
        padding: 6px;
        border: 1px solid #efefef;
    }

    .ipt_tdr, .ipt_tdhr {
        font-size: 13px !important;
    
        border: 1px solid steelgray;
        color: steelgray;
        font-weight: normal;
    }

</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrders/ListSpecialOrders.vue